const  projectsJS = [
    {
       proTitle: "JS projects", 
       projectProps: [
        {
            title: "JS - image manipulation",
            img: "/img_projects/vanilla-js/project1.png",
            desc: "Manipolazione di file d'immagini.",
            long_desc: `Piccola applicazione che tramite filtri css e le funzioni native del contex/canvas permette di effettuare alcune mofidiche all'immagine scelta come input, dando poi la possibilitá di salvare il file processato.`,
            topics: "CSS/HTML, Canvas/CTX, Javascript",
            location_url: "./web_app/projects/vanillaJS/imageManipulator/index.html",
            source_code: false        

        },
        {
            title: "JS - handeling XML/JSON",
            img: "/img_projects/vanilla-js/project2.png",
            desc: "Ottieni i dati dai file xml/json.",
            long_desc: `l'Esempio mostra come effettuare le piú comuni operazioni di lettura, scrittura cancellazione sui files XML e JSON.`,
            topics: "CSS/HTML, Javascript",
            location_url: "/web_app/projects/vanillaJS/XML_JSON_Reader/index.html",
            source_code: false        
        },
        {
            title: "JS - toDo app",
            img: "/img_projects/vanilla-js/project3.png",
            desc: "Semplice applicazione in puro javascript code.",
            long_desc: `Il codice da la possibilitá di salvare in maniera permanente i dati all'interno di localstorage del browser, i valori saranno accessibili fin quando l'utente non deciderá della loro eliminazione.`,
            topics: "CSS/HTML, Javascript",
            location_url: "./web_app/projects/vanillaJS/toDoApp/index.html",
            source_code: false        
        },
        // {
        //     title: "project JS handeling time",
        //     img: "/img_projects/vanilla-js/1.png",
        //     desc: "description project JS 3",
        //     location: "/index.html"
        // }
    ]
    }
]

export {projectsJS}
